import type {
  DuplicateAction,
  ImportExecuteRequest,
  ImportValidationResult,
} from '../../types/infrastructure'

export function buildExecuteRequest(
  validationResult: ImportValidationResult,
  duplicateAction: DuplicateAction
): ImportExecuteRequest {
  const skipHostnames =
    duplicateAction === 'skip_all'
      ? validationResult.duplicates.hostnameInDatabase.map((dup) => dup.hostname)
      : []

  return {
    fileName: validationResult.fileName,
    fileFormat: validationResult.fileFormat,
    batchId: validationResult.batchId,
    records: validationResult.records,
    skipHostnames,
    duplicateAction,
    warnings: validationResult.warnings,
  }
}

export function preflightExecuteError(
  caseId: string | null,
  validationResult: ImportValidationResult | null,
  duplicateAction: DuplicateAction
): string | null {
  if (!caseId) return 'No case selected'
  if (!validationResult) return 'No validated data available'
  if (!validationResult.valid && duplicateAction !== 'skip_all') return 'Cannot import invalid data'
  return null
}
